module.exports = __webpack_public_path__ + "static/media/install_apple.8c788967.png";